export default __webpack_public_path__ + "static/media/Ivan_Cajina_Water.f2acfbfc.jpeg";